<template>
  <section class="mcp-usage-section">
    <div class="mb-16 flex items-center justify-between">
      <h4 class="text-neutral-text-strong text-lg font-bold">MCP Usage</h4>
      <BittsFilterSelect
        v-model="timePeriod"
        :options="timePeriodOptions"
        :use-search="false"
        data-testid="mcp-usage-time-period-select"
      />
    </div>
    <BittsCallout
      :icon="['fak', 'info']"
      title="MCP Usage is in beta"
      subtitle="Tool call counts may vary as we continue to refine how tools are measured during the beta period. This data is for informational purposes only and does not yet reflect billing."
      type="info"
      size="x-small"
      class="mb-16"
      data-testid="mcp-usage-beta-banner"
    />
    <McpUsageCards :data="data" class="mb-16" />
    <McpUsageTable :data="data" :is-loading="isLoading" />
  </section>
</template>

<script setup lang="ts">
import { BittsCallout, BittsFilterSelect } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import useMcpUsage, { McpUsageTimePeriod } from '@/composables/mcp/useMcpUsage';

import McpUsageCards from './McpUsageCards.vue';
import McpUsageTable from './McpUsageTable.vue';

type TimePeriodFilter = McpUsageTimePeriod | 'all_time';

const timePeriodOptions: { label: string; value: TimePeriodFilter }[] = [
  { label: 'Last Week', value: 'last_week' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'All Time', value: 'all_time' },
];

const timePeriod = ref<TimePeriodFilter>('last_week');

const mcpTimePeriod = computed<McpUsageTimePeriod>(() =>
  timePeriod.value === 'all_time' ? undefined : timePeriod.value,
);

const { data, isLoading } = useMcpUsage(mcpTimePeriod);

defineExpose({ timePeriod });
</script>
